import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { ArticleEnums } from 'src/app/enum/article-enums';
import { InvoiceEnums } from 'src/app/enum/invoice-enums';
import { InvoiceDetailModel } from 'src/app/models/invoicing/invoice-detail.model';
import { InvoiceModel } from 'src/app/models/invoicing/invoice.model';
import { RentalStockModel } from 'src/app/models/rental/rental-stock-response.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { ArticleService } from 'src/app/services/archive/article.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { InvoiceDetailService } from 'src/app/services/invoicing/invoice-detail.service';
import { ChargeAccountService } from 'src/app/services/others/charge-account.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-register-charge-account-detail',
  templateUrl: './register-charge-account-detail.component.html',
  styleUrls: ['./register-charge-account-detail.component.scss'],
  standalone: false
})
export class RegisterChargeAccountDetailComponent implements OnChanges {
  @ViewChild('articleSelection') articleSelectionModalComponent?: CustomModalComponent | null = null;
  @Input() chargeAccountModel: InvoiceModel = new InvoiceModel();
  @Input() chargeAccountDetailContract: InvoiceDetailModel = new InvoiceDetailModel();
  @Output() updateListDetail = new EventEmitter<boolean>();
  @Output() chargeAccountContract = new EventEmitter<InvoiceModel>();
  @Output() isFormView = new EventEmitter<boolean>();

  affectsInventory: boolean = false;
  articleId: number = 0;
  ascendantArticle: boolean = true;
  articleModaldisable: boolean = false;
  columnSortArticle: string | null = null;
  componentTableSelection = CustomTableSelectComponent;
  conceptInvoicingId: number = 0;
  dataArticle: PagedResponseModel<any> = new PagedResponseModel<any>();
  filtersArticle: ColumnResponseModel[] = [];
  headerArticle: ColumnResponseModel[] = [];
  inputsForArticlesSelection$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    showCheckbox: false,
    showRecover: true,
    isMultipleSelect: true,
    filters: [],
    actions: []
  });
  limitArticle: number = 5;
  output$ = new Subject<any>();
  pageArticle: number = 1;
  articleModalState: number = 1;
  articleType: number = ArticleEnums.facturas;
  chargeAccountDetailId: number = 0;
  disableButtonSave: boolean = false;
  enableAffectsInventory: boolean = true;
  formChargeAccountDetail: FormGroup = new FormGroup({});
  listArticles: any[] = [];
  listConceptInvoicing: any[] = [];
  listStore: any[] = [];
  listStoreFiltered: any[] = [];
  stock: number = 0;
  storeId: number = 0;
  subscription: Subscription;

  constructor(private formBuilder: FormBuilder,
    private articleService: ArticleService,
    private chargeAccountService: ChargeAccountService,
    private confirmDialogService: ConfirmDialogService,
    private invoiceDetailService: InvoiceDetailService,
    private toastHandlerService: ToastHandlerService) {

  }

  async ngOnInit(): Promise<void> {
    this.validateForm(this.chargeAccountDetailContract);
    this.getAllLists();
    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChangeArticle(payload);
          break;
        case 'onFilterChange':
          this.onFilterChange(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    const chargeAccountDetailContract = changes["chargeAccountDetailContract"];
    if (chargeAccountDetailContract) {
      if (this.chargeAccountDetailContract.invoiceDetailId == 0) {
        this.createNewChargeAccountDetail();
        this.filterStoreByBranch();
      } else {
        this.chargeAccountDetailId = this.chargeAccountDetailContract.invoiceDetailId;
        this.validateForm(this.chargeAccountDetailContract);
        this.getArticle(this.chargeAccountDetailContract.articleId, false);
        this.calculateTotalValue();
        this.filterStoreByBranch();
      }
      if (this.chargeAccountDetailContract.invoiceDetailId == 0 && this.conceptInvoicingId != 0 && this.articleId != 0) {
        this.getPriceArticleByConceptInvoicing(this.chargeAccountModel.invoiceId, this.conceptInvoicingId, this.articleId);
      }
      this.chargeAccountModel.invoicingCutoffId ? setTimeout(() => this.formChargeAccountDetail.controls["residue"].enable(), 100)
        : setTimeout(() => this.formChargeAccountDetail.controls["residue"].disable(), 100);
      setTimeout(() => this.formChargeAccountDetail.controls["totalValueWithDiscount"].disable(), 100);
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  calculateTotalValue() {
    const residue = this.formChargeAccountDetail.get("residue")?.value;
    const totalTime = this.formChargeAccountDetail.get("totalTime")?.value;
    const unitValueWithDiscount = this.formChargeAccountDetail.get("unitValueWithDiscount")?.value;
    //Calculo el vr total del artículo
    const totalValue = (residue * totalTime * unitValueWithDiscount)
    this.formChargeAccountDetail.controls["totalValueWithDiscount"].setValue(totalValue);
    //Asigno el vr sin descuento
    this.formChargeAccountDetail.controls["unitValueWithoutDiscount"].setValue(unitValueWithDiscount);
  }

  changeDateIni(dateIni: Date | null) {
    this.formChargeAccountDetail.controls["dateFinal"].patchValue(dateIni);
    this.changeDateFin();
  }

  changeDateFin() {
    const fechaIni = this.convertStringToDate(this.formChargeAccountDetail.get("dateInitial")?.value);
    const fechaFin = this.convertStringToDate(this.formChargeAccountDetail.get("dateFinal")?.value);
    if (fechaFin < fechaIni) {
      this.toastHandlerService.showToast('warning', 'La fecha final debe ser MAYOR a la fecha inicial.');
    }
    const diffTime = Math.abs(fechaFin.getTime() - fechaIni.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    const totalDias = diffDays;
    this.formChargeAccountDetail.controls["totalTime"].patchValue(totalDias + 1);
    this.calculateTotalValue();
  }

  changeQuantity() {
    const quantity = this.formChargeAccountDetail.get("quantity")?.value;
    this.formChargeAccountDetail.controls["residue"].patchValue(quantity);
    if (quantity < 0 || !quantity) {
      this.toastHandlerService.showToast('warning', 'La cantidad a facturar es menor o igual a cero.');
      return;
    }
    this.calculateTotalValue();
  }

  cancel() {
    this.clearForm();
    this.isFormView.emit(false);
  }

  clearForm() {
    this.articleId = 0;
    this.conceptInvoicingId = 0;
    this.stock = 0;
    this.storeId = 0;
    this.articleModalState = InvoiceEnums.abierta;
    this.chargeAccountDetailContract = new InvoiceDetailModel;
    this.validateForm(this.chargeAccountDetailContract);
  }

  convertStringToDate(dateString: string | Date): Date {
    if (typeof dateString === 'string') {
      const [day, month, year] = dateString.split('/').map(Number);
      return new Date(year, month - 1, day);
    } else {
      return dateString;
    }
  }

  convertUtcToLocalDate(dateStr: string | Date): Date {
    const utcDate = new Date(dateStr);
    return new Date(
      utcDate.getUTCFullYear(),
      utcDate.getUTCMonth(),
      utcDate.getUTCDate()
    );
  }

  createNewChargeAccountDetail() {
    this.chargeAccountDetailId = 0;
    this.disableButtonSave = false;
    this.validateForm(this.chargeAccountDetailContract);
  }

  filterStoreByBranch() {
    this.listStoreFiltered = this.listStore.filter(x => x.branchId == this.chargeAccountModel.branchId);
  }

  async getAllLists() {
    try {
      const [conceptsInvoicing, stores, articles] = await Promise.all([
        firstValueFrom(this.invoiceDetailService.getAllConceptInvoicingForSelectAsync()),
        firstValueFrom(this.invoiceDetailService.getAllStoreForSelectAsync()),
        firstValueFrom(this.articleService.getAllArticlesForSelectAsync()),
      ]);
      this.listConceptInvoicing = conceptsInvoicing;
      this.listStore = stores;
      this.listArticles = articles;
      this.filterStoreByBranch();
      return true;
    } catch (error) {
      console.error('Error al obtener las listas.', error);
      return false;
    }
  }

  async getArticle(articleId: number | null, reload: boolean) {
    if (articleId != null && articleId != 0) {
      const article = await firstValueFrom(this.invoiceDetailService.getArticleById(articleId));
      if (article) {
        if (this.conceptInvoicingId == null || this.conceptInvoicingId == 0) {
          this.toastHandlerService.showToast('warning', 'Debe seleccionar el concepto de facturación..');
          return;
        }
        this.articleId = articleId;
      } else {
        this.articleId = 0;
        return;
      }
      if (reload) {
        this.getStore(null, true);
      }
    } else {
      this.articleId = 0;
      if (reload) {
        this.chargeAccountDetailContract = new InvoiceDetailModel();
        this.chargeAccountDetailContract.articleId = 0;
        this.chargeAccountDetailContract.conceptInvoicingId = this.conceptInvoicingId;
        this.chargeAccountDetailContract.storeId = 0;
        this.validateForm(this.chargeAccountDetailContract);
      }
    }
  }


  async getArticlesForChargeAccounts() {
    try {
      this.dataArticle = await firstValueFrom(this.invoiceDetailService.getArticlesForInvoices(this.pageArticle, this.limitArticle, this.columnSortArticle, this.ascendantArticle, this.filtersArticle));

      this.updateInputs();
    } catch (error) {
      console.error('Error al obtener la lista de los artículos', error);
    }
  }

  async getColumnsArticle() {
    try {
      this.headerArticle = await firstValueFrom(this.invoiceDetailService.getColumnsForArticles());
    } catch (error) {
      console.error('Error al buscar las columnas para la selección de artículos.', error);
    }
  }


  async getConceptInvoicing(conceptInvoicingId: number | null, reload: boolean) {
    if (conceptInvoicingId != null && conceptInvoicingId != 0) {
      const conceptInvoicing = this.listConceptInvoicing.find(x => x.value == conceptInvoicingId);
      if (conceptInvoicing) {
        this.conceptInvoicingId = conceptInvoicingId;
        this.affectsInventory = conceptInvoicing.affectsInventory === true;
        setTimeout(() => this.formChargeAccountDetail.controls["affectsInventory"].patchValue(this.affectsInventory), 150);
        //Validación para habilitar sw afecta inventario
        this.affectsInventory && this.chargeAccountDetailContract.invoiceDetailId == 0 ? this.enableAffectsInventory = false : this.enableAffectsInventory = true;
      } else {
        this.conceptInvoicingId = 0;
        return;
      }
      if (reload) {
        this.articleId = 0;
        this.storeId = 0;
        this.stock = 0;
        const modelInvoiceDetail = new InvoiceDetailModel;
        modelInvoiceDetail.articleId = 0;
        modelInvoiceDetail.conceptInvoicingId = this.conceptInvoicingId;
        modelInvoiceDetail.storeId = 0;
        this.chargeAccountDetailContract = modelInvoiceDetail;
        this.validateForm(this.chargeAccountDetailContract);
      }
    } else {
      this.conceptInvoicingId = 0;
      if (reload) {
        this.articleId = 0;
        this.storeId = 0;
        this.stock = 0;
        this.chargeAccountDetailContract = new InvoiceDetailModel();
        this.validateForm(this.chargeAccountDetailContract);
      }
    }
  }

  async getChargeAccountById(chargeAccountById: number) {
    try {
      this.chargeAccountContract.emit(await firstValueFrom(this.chargeAccountService.getChargeAccountById(chargeAccountById)));
    } catch (error) {
      console.error('Error al buscar la cuenta de cobro por id.', error);
    }
  }

  async getPriceArticleByConceptInvoicing(invoiceId: number, conceptInvoicingId: number, articleId: number) {
    try {
      this.formChargeAccountDetail.controls["unitValueWithDiscount"].patchValue(
        await firstValueFrom(this.invoiceDetailService.getPriceArticleByConceptInvoicing(invoiceId, conceptInvoicingId, articleId)));
    } catch (error) {
      this.formChargeAccountDetail.controls["unitValueWithDiscount"].patchValue(0);
      console.error('Error al buscar el precio del articulo por concepto de facturacion.', error);
    }
  }

  //Obtiene la cantidad del artículo en el almacén.
  async getStocksByArticleId(articleId: number, storeId: number) {
    if (articleId != null && articleId != 0 && storeId != null && storeId != 0) {
      const rentalStockModel = new RentalStockModel();
      rentalStockModel.articleId = this.articleId;
      rentalStockModel.storeId = this.storeId;
      rentalStockModel.dateMovement = this.chargeAccountModel.dateInvoice;
      try {
        this.stock = await firstValueFrom(this.invoiceDetailService.getStocksByArticleIdStoreId(rentalStockModel));
      } catch (error) {
        console.error('Error al buscar el stock del articulo.', error);
      }
    }
  }

  async getStore(storeId: number | null, reload: boolean) {
    if (storeId != null && storeId != 0) {
      if (this.articleId == null || this.articleId == 0) {
        this.toastHandlerService.showToast('warning', 'Debe seleccionar el artículo.');
        return;
      }
      this.storeId = storeId;
      this.getStocksByArticleId(this.articleId, this.storeId);
    } else {
      this.stock = 0;
      this.storeId = 0;
      this.formChargeAccountDetail.controls["storeId"].patchValue(this.storeId);
      if (reload) {
        const modelInvoiceDetail = new InvoiceDetailModel();
        modelInvoiceDetail.articleId = this.articleId;
        modelInvoiceDetail.conceptInvoicingId = this.conceptInvoicingId;
        modelInvoiceDetail.storeId = 0;
        this.chargeAccountDetailContract = modelInvoiceDetail;
        this.validateForm(this.chargeAccountDetailContract);
      }
    }
  }

  async handleSelectedItem(selectedItem: any) {
    const articleId = parseInt(selectedItem[0]?.id);
    this.getArticle(articleId, true)
  }

  async openArticleSelectionModal() {
    this.filtersArticle = [];
    this.updateInputs();
    await Promise.all([
      this.getColumnsArticle(),
      this.getArticlesForChargeAccounts()]
    );
    this.articleSelectionModalComponent && this.articleSelectionModalComponent.show();
  }

  async send() {
    if (this.formChargeAccountDetail.controls["quantity"].value == 0 || this.formChargeAccountDetail.controls["unitValueWithDiscount"].value == 0) {
      const accepted = await this.confirmDialogService.confirm("La cantidad o el valor de artículos a facturar es cero. ¿Realmente desea ingresar el registro?");
      if (accepted) {
        this.sendDetail();
      }
    } else {
      this.sendDetail();
    }
  }

  async sendDetail(): Promise<any> {
    //Asigno la clave de la Factura y el articulo seleccionado
    this.formChargeAccountDetail.controls["invoiceId"].patchValue(this.chargeAccountModel.invoiceId);
    this.formChargeAccountDetail.controls["articleId"].patchValue(this.articleId);
    //Habilito campos para que el formulario los tome
    this.formChargeAccountDetail.controls["residue"].enable();
    this.formChargeAccountDetail.controls["totalValueWithDiscount"].enable();

    if (this.formChargeAccountDetail.valid) {
      const modelInvoiceDetail = this.formChargeAccountDetail.value as InvoiceDetailModel;
      modelInvoiceDetail.dateInitial = this.convertStringToDate(modelInvoiceDetail.dateInitial);
      modelInvoiceDetail.dateFinal = this.convertStringToDate(modelInvoiceDetail.dateFinal);
      if (modelInvoiceDetail.document == "") modelInvoiceDetail.document = null;
      if (this.chargeAccountDetailId == 0) {
        try {
          const response = await firstValueFrom(this.invoiceDetailService.createInvoiceDetail(modelInvoiceDetail));
          this.toastHandlerService.showToast('success', 'El detalle de la cuenta de cobro fue creado exitosamente.');
          this.getChargeAccountById(response.invoiceId);
          this.chargeAccountDetailContract = new InvoiceDetailModel();
          this.clearForm()
          this.updateListDetail.emit(true);
        } catch (error) {
          console.error('Error al crear el detalle de la cuenta de cobro.', error);
        }
      } else {
        this.chargeAccountDetailContract.articleId = modelInvoiceDetail.articleId;
        this.chargeAccountDetailContract.dateInitial = this.convertStringToDate(modelInvoiceDetail.dateInitial);
        this.chargeAccountDetailContract.dateFinal = this.convertStringToDate(modelInvoiceDetail.dateFinal);
        this.chargeAccountDetailContract.document = modelInvoiceDetail.document;
        this.chargeAccountDetailContract.quantity = modelInvoiceDetail.quantity;
        this.chargeAccountDetailContract.residue = modelInvoiceDetail.residue;
        this.chargeAccountDetailContract.unitValueWithDiscount = modelInvoiceDetail.unitValueWithDiscount;
        this.chargeAccountDetailContract.unitValueWithoutDiscount = modelInvoiceDetail.unitValueWithoutDiscount;
        this.chargeAccountDetailContract.totalTime = modelInvoiceDetail.totalTime;
        this.chargeAccountDetailContract.totalValueWithDiscount = modelInvoiceDetail.totalValueWithDiscount;
        try {
          const response = await firstValueFrom(this.invoiceDetailService.updateInvoiceDetail(this.chargeAccountDetailContract));
          this.toastHandlerService.showToast('success', 'El detalle de la cuenta de cobro fue modificada exitosamente.');
          this.getChargeAccountById(response.invoiceId);
          this.chargeAccountDetailContract = new InvoiceDetailModel();
          this.clearForm()
          this.updateListDetail.emit(true);
        } catch (error) {
          this.updateListDetail.emit(true);
          console.error('Error al actualizar el detalle de la cuenta de cobro.', error);
        }
      }
    } else {
      this.showValidationMessages();
    }
    //Inhabilito campos
    this.chargeAccountModel.invoicingCutoffId ? setTimeout(() => this.formChargeAccountDetail.controls["residue"].enable(), 100)
      : setTimeout(() => this.formChargeAccountDetail.controls["residue"].disable(), 100);
    this.formChargeAccountDetail.controls["totalValueWithDiscount"].disable();
  }

  showValidationMessages() {
    const controlMessages: any = {
      articleId: {
        required: 'El campo artículo es obligatorio.',
        min: 'Debe seleccionar un artículo válido.'
      },
      conceptInvoicingId: {
        required: 'El campo concepto es obligatorio.',
        min: 'Debe seleccionar un concepto válido.'
      },
      storeId: {
        required: 'El campo bodega es obligatorio.',
        min: 'Debe seleccionar un bodega válido.'
      },
      document: {
        maxlength: 'El documento no puede tener más de 10 caracteres.'
      },
      dateInitial: {
        required: 'El campo fecha inicial es obligatorio.'
      },
      dateFinal: {
        required: 'El campo fecha final es obligatorio.'
      },
      totalTime: {
        required: 'El campo días es obligatorio.'
      },
      quantity: {
        required: 'El campo cantidad es obligatorio.'
      },
      residue: {
        required: 'El campo saldo es obligatorio.'
      },
      unitValueWithDiscount: {
        required: 'El campo valor unitario es obligatorio.'
      },
      totalValueWithDiscount: {
        required: 'El campo valor total es obligatorio.'
      }
    };

    Object.keys(controlMessages).forEach((control) => {
      const formControl = this.formChargeAccountDetail.get(control);
      if (formControl && formControl.invalid && formControl.errors) {
        const messages = controlMessages[control];
        Object.keys(formControl.errors).forEach((errorKey) => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  async onPageChangeArticle(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.pageArticle = event.page;
    this.limitArticle = event.pageSize;
    this.columnSortArticle = event.sortField || null;
    this.ascendantArticle = event.sortOrder === 1;
    this.getArticlesForChargeAccounts();
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters.map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index).map((item: any) => item.value);
    this.filtersArticle = this.removeDuplicates(filters);
    this.filtersArticle.forEach((filter: any) => this.processFilter(filter));
    this.updateInputs();
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filtersArticle = this.filtersArticle.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filtersArticle.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  updateInputs() {
    this.inputsForArticlesSelection$.next({
      headers: this.headerArticle,
      data: this.dataArticle,
      showCheckbox: true,
      showRecover: true,
      isMultipleSelect: false,
      limitPaginator: true,
      filters: this.filtersArticle,
      actions: [
        {
          action: 'view-image',
          label: 'Imágenes',
          icon: 'pi pi-image'
        }
      ]
    });
  }

  validateForm(chargeAccountDetailModel: InvoiceDetailModel) {
    this.formChargeAccountDetail = this.formBuilder.group({
      invoiceId: [chargeAccountDetailModel.invoiceId, [Validators.required, Validators.min(1)]],
      articleId: [chargeAccountDetailModel.articleId, [Validators.required, Validators.min(1)]],
      conceptInvoicingId: [chargeAccountDetailModel.conceptInvoicingId, [Validators.required, Validators.min(1)]],
      storeId: [chargeAccountDetailModel.storeId, [Validators.required, Validators.min(1)]],
      affectsInventory: [chargeAccountDetailModel.affectsInventory, []],
      document: [chargeAccountDetailModel.document, [Validators.maxLength(10)]],
      dateInitial: [new Date(chargeAccountDetailModel.dateInitial).toLocaleDateString('es-US'), [Validators.required]],
      dateFinal: [new Date(chargeAccountDetailModel.dateFinal).toLocaleDateString('es-US'), [Validators.required]],
      totalTime: [chargeAccountDetailModel.totalTime, [Validators.required]],
      quantity: [chargeAccountDetailModel.quantity, [Validators.required]],
      residue: [chargeAccountDetailModel.residue, [Validators.required]],
      unitValueWithDiscount: [chargeAccountDetailModel.unitValueWithDiscount, [Validators.required]],
      unitValueWithoutDiscount: [chargeAccountDetailModel.unitValueWithoutDiscount, [Validators.required]],
      totalValueWithDiscount: [chargeAccountDetailModel.totalValueWithDiscount, [Validators.required]]
    });
    this.articleId = chargeAccountDetailModel.articleId;
    this.conceptInvoicingId = chargeAccountDetailModel.conceptInvoicingId;
    this.storeId = chargeAccountDetailModel.storeId;
    if (this.chargeAccountModel.invoiceStateId != InvoiceEnums.abierta) this.disableButtonSave = true;
    if (chargeAccountDetailModel.invoiceDetailId != 0) {
      this.formChargeAccountDetail.controls["conceptInvoicingId"].disable();
      this.formChargeAccountDetail.controls["storeId"].disable();
      this.formChargeAccountDetail.controls["affectsInventory"].disable();
      this.articleModalState = InvoiceEnums.cerrada;
    }

    this.chargeAccountModel.invoicingCutoffId ? setTimeout(() => this.formChargeAccountDetail.controls["residue"].enable(), 100)
      : setTimeout(() => this.formChargeAccountDetail.controls["residue"].disable(), 100);
    setTimeout(() => this.formChargeAccountDetail.controls["totalValueWithDiscount"].disable(), 100);
  }

}
